<script>
  import { tausender_trenner } from "./UtilsBalkenProgress.svelte";
  import { find_help_text_if_exists } from "./Utils.svelte";

  export let max_value;
  export let value;
  export let vorgaenger = 0;
  export let is_basis_balken = false;

  let heigth = 80;
  let text_box_heigh = 7;

  export let background_color_bottom = "#afcb08";
  export let background_color_mitte = "#ffffff";
  export let border_color_mitte = "#FFFFFF";

  export let vorgaenger_box_color = false;
  export let is_total = false;
  export let total_text = "";

  export let helptexts;
  export let in_show_helptext_id;

  function lower_heigth(max_value, value) {
    var heigth_faktor = heigth / max_value;
    // console.log("heigth_faktor: ", heigth_faktor)

    var is_total_faktor = 0;
    if (is_total) {
      is_total_faktor = 1.2;
    }

    return value * heigth_faktor * is_total_faktor;
  }

  function upper_heigth(max_value, value, vorgaenger) {
    var heigth_faktor = heigth / max_value;
    // console.log("value: ", value)
    // console.log("upper_heigth: ", text_box_heigh - (value * heigth_faktor + vorgaenger * heigth_faktor));

    return heigth - (value * heigth_faktor + vorgaenger * heigth_faktor);
  }

  function vorgaenger_heigth(max_value, value, vorgaenger) {
    var heigth_faktor = heigth / max_value;
    return vorgaenger * heigth_faktor;
  }
</script>

<div class="center-outer" style="margin-left: 0px;margin-right: 0px;margin-top: 0px;">
  <table height="{heigth}px;">
    <tr height="{upper_heigth(max_value, value, vorgaenger)}px;">
      <div class="breite"><!-- &nbsp; --></div>
    </tr>

    <tr height="{text_box_heigh}px;">
      <div
        class="breite borderstyle info-circle"
        style="background-color: {background_color_mitte}; font-weight: 500; border: solid {border_color_mitte} 0.25pt; text-align: center; vertical-align: middle;"
      >
        {#if is_basis_balken}
          <div class="info-box">
            {#if find_help_text_if_exists(helptexts, "marketing_mirror_new_leads")}
              {@html find_help_text_if_exists(helptexts, "marketing_mirror_new_leads")}
            {:else}
              Median of the last 12 months before the start of the selected time frame
              <br /><br />
            {/if}
            {#if in_show_helptext_id}
              <div style="font-size: 7px">id: marketing_mirror_new_leads</div>
              <div style="font-size: 7px">
                [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
              </div>
            {/if}
          </div>
        {/if}
        {tausender_trenner(value)}
      </div>
    </tr>

    <tr style="height: 1px; max-height: 1px;">
      <div style="height: 1px; max-height: 1px;" />
    </tr>

    <tr height="{lower_heigth(max_value, value)}px;">
      <td style="height:100%; padding:0px;">
        <div class="breite" style="background-color: {background_color_bottom}">
          {#if is_total}
            <div class="crossed" />
          {/if}
        </div>
      </td>
      {#if is_total}
        <td class="" style="vertical-align: top">
          <div class="breite" style="text-align:  center;height: 12px; color: #FFFFFF; background-color: {background_color_bottom}">
            {tausender_trenner(total_text)}
          </div>
        </td>
      {/if}
    </tr>

    {#if vorgaenger > 0}
      <tr height="{vorgaenger_heigth(max_value, value, vorgaenger)}px;">
        <div
          class="breite"
          style="{vorgaenger_box_color
            ? 'background-color: ' + vorgaenger_box_color + '; color: ' + '#000000; vertical-align: bottom;'
            : 'vertical-align: top; color: green;'} 
       opacity: 1.0;
       border-top: solid 0.25px #d9d9d9;
       border-left: solid 0.25px #d9d9d9;
       border-right: solid 0.25px #d9d9d9;
       text-align: center;
       "
        >
          {#if !is_total}
            +
          {/if}

          {tausender_trenner(vorgaenger)}
        </div>
      </tr>
    {/if}
  </table>
</div>

<style>
  .center-outer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  div {
    height: 100%;
    font-size: 10px;
  }
  .breite {
    width: 40px;
  }
  .center-text {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
  tr {
    width: 40px;
  }

  .crossed {
    width: 57px;
    height: 47px;
    border-bottom: 10px solid white;
    -webkit-transform: translateY(0px) translateX(-20px) rotate(-20deg);
    position: absolute;
    /* top: -20px; */
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #717171;
    font-size: 10px;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    height: auto;
    /*text-transform: uppercase;*/
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }
</style>
